import script from "./MypageSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./MypageSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./MypageSidebar.vue?vue&type=style&index=0&id=8228b3bc&lang=css"

const __exports__ = script;

export default __exports__